import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Storage from "../../services/Storage";
import "./Breadcrumbs.css";
export const Breadcrumbs = ({ title: subtitle = "", from = "page", isPageLoad = false }) => {
  let breadcrumbs = Storage.getBreadcrumbsrRecord() || [];
  const [breadCrumbsLocal, setBreadCrumbsLocal] = useState(breadcrumbs);
  const location = useLocation();
  useEffect(() => {
    if (breadcrumbs && breadcrumbs.length && from === "page") {
      const index = location.title ? breadcrumbs.findIndex(x => x.url === location.pathname && x.title === location.title) : breadcrumbs.findIndex(x => x.url === location.pathname);
      if (index > -1 && !isPageLoad) {
        breadcrumbs = breadcrumbs.splice(0, index);
        Storage.removeBreadcrumbsrRecord();
        Storage.setBreadcrumbsrRecord([...breadcrumbs]);
        setBreadCrumbsLocal([...breadcrumbs])
      } else if (index === 0) {
        Storage.removeBreadcrumbsrRecord();
        setBreadCrumbsLocal([]);
      } else {
        setBreadCrumbsLocal(breadcrumbs)
      }
    } else {
      setBreadCrumbsLocal(breadcrumbs)
    }
  }, [breadcrumbs.length])

  return (
    <div id="Breadcrumbs">
      {breadCrumbsLocal && breadCrumbsLocal.length > 0 ? (
        <div className="subHeaderLink">
          {breadCrumbsLocal.map((elem, index) => {
            const { title} = elem;
            return <span key={`${index}-${title}`}>{title}</span>;
          })}
          {subtitle ? <span>{subtitle}</span> : ""}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
